 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import XHTMLPORTALISTAD_1 from '@/components/xhtml/portalistad_1'
 import XHTMLALST from '@/components/xhtml/ALST'
 import XHTMLFM from '@/components/xhtml/fm'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLFM01 from '@/components/xhtml/fm01'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCHAPTER001 from '@/components/xhtml/chapter001'
 import XHTMLCHAPTER002 from '@/components/xhtml/chapter002'
 import XHTMLCHAPTER003 from '@/components/xhtml/chapter003'
 import XHTMLCHAPTER004 from '@/components/xhtml/chapter004'
 import XHTMLCHAPTER005 from '@/components/xhtml/chapter005'
 import XHTMLCHAPTER006 from '@/components/xhtml/chapter006'
 import XHTMLCHAPTER007 from '@/components/xhtml/chapter007'
 import XHTMLCHAPTER008 from '@/components/xhtml/chapter008'
 import XHTMLCHAPTER009 from '@/components/xhtml/chapter009'
 import XHTMLCHAPTER010 from '@/components/xhtml/chapter010'
 import XHTMLCHAPTER011 from '@/components/xhtml/chapter011'
 import XHTMLCHAPTER012 from '@/components/xhtml/chapter012'
 import XHTMLCHAPTER013 from '@/components/xhtml/chapter013'
 import XHTMLCHAPTER014 from '@/components/xhtml/chapter014'
 import XHTMLCHAPTER015 from '@/components/xhtml/chapter015'
 import XHTMLCHAPTER016 from '@/components/xhtml/chapter016'
 import XHTMLCHAPTER017 from '@/components/xhtml/chapter017'
 import XHTMLCHAPTER018 from '@/components/xhtml/chapter018'
 import XHTMLCHAPTER019 from '@/components/xhtml/chapter019'
 import XHTMLCHAPTER020 from '@/components/xhtml/chapter020'
 import XHTMLCHAPTER021 from '@/components/xhtml/chapter021'
 import XHTMLCHAPTER022 from '@/components/xhtml/chapter022'
 import XHTMLCHAPTER023 from '@/components/xhtml/chapter023'
 import XHTMLCHAPTER024 from '@/components/xhtml/chapter024'
 import XHTMLCHAPTER025 from '@/components/xhtml/chapter025'
 import XHTMLCHAPTER026 from '@/components/xhtml/chapter026'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import PREVIEWSTART from '@/components/Preview/start'
 import PREVIEW00_COVER from '@/components/Preview/00_cover'
 import PREVIEWCHAPTER001 from '@/components/Preview/chapter001'
 import PREVIEWCHAPTER002 from '@/components/Preview/chapter002'
 import PREVIEWCHAPTER003 from '@/components/Preview/chapter003'
 import XHTMLDEDICATED from '@/components/xhtml/dedicated'
 import XHTMLABOUT from '@/components/xhtml/about'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLAUBA from '@/components/xhtml/auba'
 import XHTMLORIMAD from '@/components/xhtml/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_cover",
 			"name" : "xhtml/00_cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/EBB",
 			"name" : "xhtml/EBB",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/portalistad_1",
 			"name" : "xhtml/portalistad_1",
 			"component" : XHTMLPORTALISTAD_1
 		},
 		{
 			"path" : "/xhtml/ALST",
 			"name" : "xhtml/ALST",
 			"component" : XHTMLALST
 		},
 		{
 			"path" : "/xhtml/fm",
 			"name" : "xhtml/fm",
 			"component" : XHTMLFM
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/fm01",
 			"name" : "xhtml/fm01",
 			"component" : XHTMLFM01
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/chapter001",
 			"name" : "xhtml/chapter001",
 			"component" : XHTMLCHAPTER001
 		},
 		{
 			"path" : "/xhtml/chapter002",
 			"name" : "xhtml/chapter002",
 			"component" : XHTMLCHAPTER002
 		},
 		{
 			"path" : "/xhtml/chapter003",
 			"name" : "xhtml/chapter003",
 			"component" : XHTMLCHAPTER003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js